import { ChasingDots } from "better-react-spinkit";
import styled from "styled-components";
import { themeGet } from "styled-system";

import colors from "../../themes/policystat/colors";

// TODO: change size prop to be something that gives more context, such as sm or lg

const LoadingSpinnerContainer = styled("div")`
  display: inline-block;
  margin-left: ${themeGet("space.1")}px;
  margin-right: ${themeGet("space.1")}px;
`;

const LoadingSpinner = props => (
  <LoadingSpinnerContainer>
    <ChasingDots
      display="inline"
      color={props.colorOne || colors["secondary"][0]}
      colorTwo={props.colorTwo || colors["primary"][0]}
      size={props.size}
    />
  </LoadingSpinnerContainer>
);

export default LoadingSpinner;
